import { setComponentInvalid } from 'reduxes/slices/invalid/actions'

import { makeActionCreator } from '../../util/make_action_creator'

// Action cable
export const CABLECAR_LOADED = 'CABLECAR_LOADED'
export const CABLECAR_CONNECTED = 'redux-cablecar/CONNECTED'
export const CABLECAR_DISCONNECTED = 'redux-cablecar/DISCONNECTED'

export const loadCableCar = makeActionCreator(CABLECAR_LOADED, 'cablecar')

export function cableCarDisconnected() {
  return function (dispatch) {
    dispatch(setComponentInvalid('cablecar'))
  }
}
